import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BaasicFormControls, BaasicButton, DatePickerField, BasicInput, BaasicConfirmModal } from 'core/components';

function PatientNewFlowInsuranceEditModalTemplate({ patientNewFlowInsuranceEditModalStore, t, disableForm }) {
    const {
        form,
        insuranceStore,
        contactRelationshipStore,
        action,
        title,
        isActive,
        closeAll,
        insuranceChangeConfirmModal
    } = patientNewFlowInsuranceEditModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>{title}</h3>
            </div>
            <div className="modal__body">
                <div className="row">
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BaasicFieldDropdown field={form.$('name')} store={insuranceStore} allowEmpty={true} disabled={action === "edit"} />
                    </div>
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BasicInput field={form.$('policyNumber')} />
                    </div>
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <DatePickerField field={form.$('effectiveDate')} disabled={action === "edit" || form.submitting || form.validating} />
                    </div>
                    {!isActive &&
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <DatePickerField field={form.$('effectiveEndDate')} disabled={action === "edit"|| form.submitting || form.validating} />
                        </div>
                    }
                    {action !== "edit" &&
                        <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                            <BaasicFieldDropdown field={form.$('contactRelationship')} store={contactRelationshipStore} />
                        </div>
                    }

                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    disabled={disableForm}
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => closeAll()}
                />
                <BaasicFormControls
                    className='btn btn--med btn--primary'
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating || disableForm}
                    label="Save"
                />
            </div>
            <BaasicConfirmModal modalParams={insuranceChangeConfirmModal} />
        </section>
    )
}

PatientNewFlowInsuranceEditModalTemplate.propTypes = {
    patientNewFlowInsuranceEditModalStore: PropTypes.object,
    t: PropTypes.func,
    disableForm: PropTypes.bool
};

export default defaultTemplate(PatientNewFlowInsuranceEditModalTemplate);
